<template>
  <v-dialog v-model="open" persistent max-width="450">
    <v-card>
      <v-card-title>Billing Details</v-card-title>
      <v-card-text>
        <v-text-field label="Business name" :disabled="getIsUpdateAccountLoading" v-model="business_name" :error-messages="businessNameErrors" @input="$v.business_name.$touch()" @blur="$v.business_name.$touch()" outlined dense class="mb-0"></v-text-field>
        <v-divider></v-divider>
        <AddressForm :passedAddress="passedAddress"/>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click.prevent="updateInsAddress" :disabled="installAddressEdit||getIsUpdateAccountLoading" :loading="getIsUpdateAccountLoading">Save</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters,mapState,mapActions } from "vuex";
import AddressForm from "../Misc/AddressForm";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    business_name: { required },
  },
  data: () => ({
    business_name: '',
    passedAddress: {
      line_one: '',
      line_two: '',
      city: '',
      county: '',
      post_code: '',
      country: ''
    }
  }),
  props: {
    open: Boolean,
    close: Function,
    account: Object
  },
  components: {
    AddressForm
  },
  computed: {
    ...mapState('globals', ['selectedAddress']),
    ...mapGetters("accounts", ["getCurrentAccount", "getIsUpdateAccountLoading", "getIsUpdateAccountError"]),

    installAddressEdit(){
      return Object.keys(this.selectedAddress).length===0;
    },
    businessNameErrors() {
      const errors = [];
      if (!this.$v.business_name.$dirty) return errors;
      !this.$v.business_name.required && errors.push("Business name is a required field");
      return errors;
    },
  },
  watch: {
    account(newValue) {
      this.business_name = this.getCurrentAccount.business_name;
      this.passedAddress = {
        line_one: newValue.address_line_one,
        line_two: newValue.address_line_two,
        city: newValue.address_city,
        county: newValue.address_region,
        post_code: newValue.address_post_code,
        country: newValue.address_country
      };
    }
  },
  methods: {
    ...mapActions("accounts", ["updateAccount"]),
    ...mapActions("alerts", ["setAlert"]),
    async updateInsAddress(){
      let updateData = {
        business_name: this.business_name,
        address_line_one: this.selectedAddress.line_one,
        address_line_two: this.selectedAddress.line_two,
        address_city: this.selectedAddress.city,
        address_region: this.selectedAddress.county,
        address_post_code: this.selectedAddress.post_code,
        address_country: this.selectedAddress.country
      };

      await this.updateAccount({ id: this.account.id, data: updateData });

      if(!this.getIsUpdateAccountError) {
        this.$emit('update-topbar');
        this.closeDialog();
      }
    },

    setForm() {
      this.business_name = this.getCurrentAccount.business_name;
      this.passedAddress = {
        line_one: this.account.address_line_one,
        line_two: this.account.address_line_two,
        city: this.account.address_city,
        county: this.account.address_region,
        post_code: this.account.address_post_code,
        country: this.account.address_country
      };
    },

    closeDialog() {
      this.setForm();
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
